export default {
  // 视图的标题
  version: '0.9.1',
  title: '默认视图',
  viewType: '3',
  permission: {
    type: 'protected',
    partiedBy: [],
  },
  // 用于控制该视图下字段的显隐和顺序，数据格式如下
  // {
  //   "slug": "tableDataId",
  //   "type": "identifier",
  //   "group": "system",
  //   "title": "编号",
  //   "nodeTemplateId": 2774,
  //   "showType": "sticky"   // 这里控制字段如何显示， 可以取值 sticky(固定) , hidden(隐藏), shown(显示)
  // },
  columnsConfig: [{ slug: 'tableDataId', showType: 'sticky' }],
  // filters 用来控制表单的筛选条件，数据格式如下
  // {
  //   "queries": [           // queries 是一个数组，可以每项都是一个筛选条件，这里建议可以用 toolbar 来生成筛选条件的查询
  //     {
  //       "id": 2792,
  //       "slug": "source",
  //       "value": [
  //         "市民热线举报"
  //       ],
  //       "queryType": "containedByArray"
  //     }
  //   ],
  //   "logicType": "and"     // 用来控制筛选的逻辑形式，可以是 and 或者 or
  // },
  filters: {},
  // sorts 用来控制表单的排序，数据格式如下
  // {
  //   "slug": "tableDataId",
  //   "type": "identifier",
  //   "desc": false,
  //   "nodeTemplateId": 2774
  // }
  sorts: {},
  color: {},
  group: {},
  rowHeight: 32,
  // buttons 用来控制表单工具栏显示的按钮
  buttons: [
    {
      title: '隐藏列',
      align: 'left',
      type: 'Columns',
    },
    {
      title: '筛选',
      align: 'left',
      type: 'Filters',
    },
    {
      title: '排序',
      align: 'left',
      type: 'Sort',
    },
    {
      title: '颜色',
      align: 'left',
      type: 'Color',
    },
    {
      title: '行高',
      align: 'left',
      type: 'RowHeight',
    },
    {
      title: '导入',
      align: 'left',
      type: 'Import',
    },
    {
      title: '导出',
      align: 'left',
      type: 'Export',
    },
    // {
    //   title: '设置',
    //   align: 'left',
    //   type: 'Config',
    // },
    // {
    //   title: '导出',
    //   align: 'left',
    //   type: 'Export',
    // },
  ],
  // selectedButtons 用来控制当有记录被选中时表单工具栏显示的按钮
  selectedButtons: [
    {
      title: '导出',
      align: 'left',
      type: 'Export',
    },
    {
      title: '编辑',
      align: 'left',
      type: 'Edit',
    },
    {
      title: '删除',
      align: 'left',
      type: 'Delete',
    },
  ],
  // createBtn 用来控制表单工具栏是否显示录入按钮
  createBtn: {
    show: true,
    forms: [],
  },

  editBtn: {
    show: true,
    forms: [],
  },
  // 开发按钮
  devButtons: [
    {
      title: '设置',
      align: 'left',
      type: 'Config',
    },
  ],
}
